<template>
  <div class="control_bar top">
    <div class="search">
      <input
        type="text"
        class="search_field"
        placeholder="端末名、電話番号から検索"
        v-model="inputValue"
      />
      <input
        type="button"
        :value="search"
        class="search_button"
        @click="deviceFindAction"
      />
    </div>
    <controller
      :dispItems="dispItems"
      :allItems="devices"
      :router="router"
      @remove="remove"
      @import="importModal"
      @exportFile="exportFile"
    >
    </controller>
    <div class="false_modal_window" v-if="showFinishModal">
      <finishModalWindow :question="finishWord" @close="close">
      </finishModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
    <div class="import_modal_window" v-if="showImportModal">
      <importModalWindow @close="closeModal" @import="importFile">
      </importModalWindow>
    </div>
  </div>
</template>

<script>
import controller from '../controller.vue'
import finishModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import importModalWindow from '../modalWindow/importModalWindow.vue'

export default {
  props: ['dispItems'],
  data() {
    return {
      inputValue: '',
      search: '検索',
      showFinishModal: false,
      finishWord: '',
      router: '/devices/add',
      showloadingModal: false,
      showImportModal: false,
      records: [],
      csvData: [],
      confirmed: ''
    }
  },
  computed: {
    devices() {
      return this.$store.state.devices.devices
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    indexOfCallAppList() {
      return this.$store.state.masters.masterData.callAppList.length
    },
    selectedDeviceList() {
      return this.$store.state.devices.selectedDeviceList
    }
  },
  components: {
    controller,
    finishModalWindow,
    loadingModalWindow,
    importModalWindow
  },
  methods: {
    close(e) {
      this.showFinishModal = false
    },
    closeModal(e) {
      this.showImportModal = false
      this.showFinishModal = false
    },
    async remove(e) {
      let selectedDeviceIdList = this.selectedDeviceList.map(device => {
        let deviceId = device.deviceId
        return {deviceId}
      })
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'devices/deleteDevices',
          selectedDeviceIdList
        )
        this.$store.dispatch('devices/clearSelectedDeviceList')
        this.finishWord = '対象の端末を削除しました。'
        this.showFinishModal = true
        // 削除ボタン押下時は詳細画面を初期化する
        if (location.pathname !== '/devices') {
          this.$router.push('/devices')
        }
        this.$emit('list-reload')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_140003
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0020') {
            this.finishWord =
              this.errorMsg.MSGCRC0020.name +
              this.errorMsg.MSGCRC0020.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.finishWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0020'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0020.name +
            this.errorMsg.MSGCRC0020.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    },
    deviceFindAction(event) {
      this.$emit('input-event', 0, this.inputValue)
      this.confirmed = this.inputValue
    },
    importModal(e) {
      this.records = e
      this.showImportModal = true
    },
    async importFile(e) {
      e = this.records
      this.showImportModal = false
      this.showloadingModal = true
      var createList = []
      var headerFlg = false
      for (let i = 0; i < e.length; i++) {
        let obj = {}
        let header = this.$store.state.error.exportTitle.deviceTitle.replace(
          '\r\n',
          ''
        )
        let data = e[i].replace('\r', '')
        if (data !== header) {
          this.csvSplit(data)
          var csvArrayList = this.csvData
          this.csvData = []
          if (
            csvArrayList.length !==
            this.$store.state.error.importErrorNumber.importDeviceNumber
          ) {
            let eventNumber = this.$store.state.error.errorCode.errorCode_140007
            let eventType = 9
            let reason = 'MSGCRC0008'
            try {
              this.$store.dispatch('masters/writeLog', {
                eventNumber,
                eventType,
                reason
              })
            } catch (error) {}
            this.finishWord =
              this.errorMsg.MSGCRC0008.name +
              this.errorMsg.MSGCRC0008.beforeValue +
              (i + 1) +
              this.errorMsg.MSGCRC0008.afterValue +
              'エラーコード：{' +
              eventNumber +
              '}'
            this.showFinishModal = true
            this.showloadingModal = false
            return
          }
          var upperedValue = csvArrayList[3].toUpperCase()
          if (upperedValue === '') {
            let eventNumber = this.$store.state.error.errorCode.errorCode_140009
            let eventType = 9
            let reason = 'MSGCRC0164'
            try {
              this.$store.dispatch('masters/writeLog', {
                eventNumber,
                eventType,
                reason
              })
            } catch (error) {}
            this.finishWord =
              this.errorMsg.MSGCRC0164.name +
              (i + 1) +
              '行目：' +
              this.errorMsg.MSGCRC0164.value +
              'エラーコード：{' +
              eventNumber +
              '}'
            this.showFinishModal = true
            this.showloadingModal = false
            return
          }
          if (upperedValue !== 'TRUE' && upperedValue !== 'FALSE') {
            let eventNumber = this.$store.state.error.errorCode.errorCode_140009
            let eventType = 9
            let reason = 'MSGCRC0165'
            try {
              this.$store.dispatch('masters/writeLog', {
                eventNumber,
                eventType,
                reason
              })
            } catch (error) {}
            this.finishWord =
              this.errorMsg.MSGCRC0165.name +
              (i + 1) +
              '行目：' +
              this.errorMsg.MSGCRC0165.value +
              'エラーコード：{' +
              eventNumber +
              '}'
            this.showFinishModal = true
            this.showloadingModal = false
            return
          }
          if (csvArrayList[4] === '') {
            let eventNumber = this.$store.state.error.errorCode.errorCode_140009
            let eventType = 9
            let reason = 'MSGCRC0166'
            try {
              this.$store.dispatch('masters/writeLog', {
                eventNumber,
                eventType,
                reason
              })
            } catch (error) {}
            this.finishWord =
              this.errorMsg.MSGCRC0166.name +
              (i + 1) +
              '行目：' +
              this.errorMsg.MSGCRC0166.value +
              'エラーコード：{' +
              eventNumber +
              '}'
            this.showFinishModal = true
            this.showloadingModal = false
            return
          }
          obj['deviceId'] = csvArrayList[0]
          obj['deviceName'] = csvArrayList[1]
          obj['phoneNumber'] = csvArrayList[2]
          obj['personalDeviceFlag'] = upperedValue === 'TRUE'
          obj['callAppDivision'] = csvArrayList[4].replace(/[\r\n]/g, match => {
            if (match === '\r') {
              return ''
            } else {
              return ''
            }
          })
          obj['fileRowCount'] = String(i + 1)
          createList.push(obj)
        } else {
          headerFlg = true
        }
      }

      if (location.pathname !== '/devices') {
        this.$router.push('../devices')
      }
      try {
        await this.$store.dispatch('devices/importDevices', createList)
        this.$emit('list-reload')
        this.finishWord = 'インポートしました。'
        this.showFinishModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_140009
        let eventType = 3
        let reason = '端末情報のインポートに失敗しました。'
        if (error.response && error.response.data) {
          if (error.response.data.header) {
            let errorMessage = error.response.data.header.message.split(',')
            if (errorMessage[0] === 'MSGCRC0014') {
              this.finishWord =
                this.errorMsg.MSGCRC0014.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0014.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0015') {
              this.finishWord =
                this.errorMsg.MSGCRC0015.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0015.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0092') {
              this.finishWord =
                this.errorMsg.MSGCRC0092.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0092.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0097') {
              this.finishWord =
                this.errorMsg.MSGCRC0097.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0097.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0098') {
              this.finishWord =
                this.errorMsg.MSGCRC0098.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0098.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0124') {
              this.finishWord =
                this.errorMsg.MSGCRC0124.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0124.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0130') {
              this.finishWord =
                this.errorMsg.MSGCRC0130.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0130.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0146') {
              this.finishWord =
                this.errorMsg.MSGCRC0146.name +
                this.errorMsg.MSGCRC0146.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0162') {
              this.finishWord =
                this.errorMsg.MSGCRC0162.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0162.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0163') {
              this.finishWord =
                this.errorMsg.MSGCRC0163.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0163.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0164') {
              this.finishWord =
                this.errorMsg.MSGCRC0164.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0164.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0165') {
              this.finishWord =
                this.errorMsg.MSGCRC0165.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0165.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0166') {
              this.finishWord =
                this.errorMsg.MSGCRC0166.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0166.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0167') {
              this.finishWord =
                this.errorMsg.MSGCRC0167.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0167.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0168') {
              this.finishWord =
                this.errorMsg.MSGCRC0168.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0168.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0185') {
              this.finishWord =
                this.errorMsg.MSGCRC0185.name +
                (Number(errorMessage[1]) + 1) +
                this.errorMsg.MSGCRC0185.beforeValue +
                errorMessage[1] +
                this.errorMsg.MSGCRC0185.afterValue +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0264') {
              this.finishWord =
                this.errorMsg.MSGCRC0264.name +
                this.errorMsg.MSGCRC0264.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else {
              this.finishWord =
                this.errorMsg.MSGCRC0021.name +
                this.errorMsg.MSGCRC0021.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            }
            reason = errorMessage[0] + ' '
            reason += error.response.status
          } else {
            var obj = error.response.data
            var stringName = Object.keys(obj)[0]
            var errorMessage
            if (headerFlg) {
              errorMessage = Number(Object.keys(obj)[0].substring(16, 17)) + 2
            } else {
              errorMessage = Number(Object.keys(obj)[0].substring(16, 17)) + 1
            }
            if (stringName.endsWith('callAppDivision')) {
              this.finishWord =
                this.errorMsg.MSGCRC0167.name +
                errorMessage +
                '行目：' +
                this.errorMsg.MSGCRC0167.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = 'MSGCRC0167'
            } else if (error.response.status === 502) {
              reason = 'MSGCRC0021'
              eventType = 9
              this.finishWord =
                this.errorMsg.MSGCRC0021.name +
                this.errorMsg.MSGCRC0021.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else {
              this.finishWord =
                this.errorMsg.MSGCRC0195.name +
                this.errorMsg.MSGCRC0195.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = 'MSGCRC0195'
            }
          }
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    },
    csvSplit(line) {
      let c = ''
      let s = ''
      let before = ''
      let singleQuoteFlg = false
      let escapeFlg = false
      for (let i = 0; i < line.length; i++) {
        before = c
        c = line.charAt(i)
        if (c === ',' && !singleQuoteFlg) {
          this.csvData.push(s)
          s = ''
        } else if (c === ',' && singleQuoteFlg) {
          s = s + c
        } else if (c === '"') {
          if (before === '"' && escapeFlg) {
            s = s + c
            escapeFlg = false
          } else {
            if (i !== line.lengt - 1) {
              // 最終文字ではない場合
              if (line.charAt(i + 1) === '"' && singleQuoteFlg) {
                escapeFlg = true
              } else {
                singleQuoteFlg = !singleQuoteFlg
              }
            } else {
              singleQuoteFlg = !singleQuoteFlg
            }
          }
        } else {
          s = s + c
        }
      }
      if (line.charAt(line.length - 1) === ',') {
        // csvファイルの行の最終文字が , の場合
        this.csvData.push('')
      } else {
        this.csvData.push(s)
      }
    },
    async exportFile() {
      var selectedDeviceIdList = this.selectedDeviceList.map(device => {
        return {deviceId: device.deviceId}
      })
      this.showloadingModal = true
      try {
        const params = {selectedDeviceIdList: selectedDeviceIdList}
        if (selectedDeviceIdList.length === 0) {
          params.searchWord = this.confirmed ? this.confirmed : ''
        }
        await this.$store.dispatch('devices/setExportData', params)

        const exportList = this.$store.state.devices.exportData
        let result = this.$store.state.error.exportTitle.deviceTitle
        for (let i = 0; i < exportList.length; i++) {
          for (let k of Object.keys(exportList[i])) {
            if (!exportList[i][k] && k !== 'personalDeviceFlag') {
              exportList[i][k] = ''
            }
          }
          result +=
            exportList[i].deviceId +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].deviceName) +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].phoneNumber2) +
            ',' +
            exportList[i].personalDeviceFlag +
            ',' +
            exportList[i].callAppDivision +
            ',' +
            exportList[i].createDateTime +
            ',' +
            exportList[i].lastUpdateDateTime +
            '\r\n'
        }
        if (result === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_140008
          let eventType = 9
          let reason = 'MSGCRC0006'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0006.name +
            this.errorMsg.MSGCRC0006.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }
        let csv = ''
        csv += result
        let link = document.createElement('a')
        let bom = new Uint8Array([0xef, 0xbb, 0xbf])
        let blob
        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([bom, csv], {type: 'text/csv'})
          window.navigator.msSaveOrOpenBlob(blob, '端末一覧.csv')
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', '端末一覧.csv')
          link.setAttribute('href', window.webkitURL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', '端末一覧.csv')
          link.setAttribute('href', window.URL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else {
          let eventNumber = this.$store.state.error.errorCode.errorCode_140005
          let eventType = 9
          let reason = 'MSGCRC0007'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0007.name +
            this.errorMsg.MSGCRC0007.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }
        window.URL.revokeObjectURL(link)
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_140006
        let eventType = 3
        let reason = ''
        if (error.response) {
          reason = 'MSGCRC0022 '
          this.finishWord =
            this.errorMsg.MSGCRC0022.name +
            this.errorMsg.MSGCRC0022.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
        this.showloadingModal = false
        return
      }
      this.showloadingModal = false
    },
    exportSetDoubleQuotation(value) {
      let c = ''
      let s = ''
      let doubleQuoteFlg = false
      // ダブルクォーテーションのエスケープ処理
      for (let i = 0; i < value.length; i++) {
        c = value.charAt(i)
        if (c === '"') {
          doubleQuoteFlg = true
          s = s + '"' + c
        } else {
          s = s + c
        }
      }
      if (doubleQuoteFlg) {
        s = '"' + s + '"'
      }
      // カンマがある場合、ダブルクォーテーションで囲む
      if (s.indexOf(',') >= 0 && !doubleQuoteFlg) {
        return '"' + s + '"'
      }
      return s
    }
  }
}
</script>

<style scoped>
.search {
  margin: auto 0;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/devices/controlbar.vue